/* assets/alb-wasserhaerte-check.js · ALB Horizon Rebuild
   Wasserhärte-Check: PLZ eingeben → Härte (°dH) aus assets/alb-wasserhaerte-<land>-<ziffer>.json.
   Daten: hardness.sql (Alb Filter, Stand 10/2026), aufbereitet mit wasserhaerte-plz/prepare.py + export_theme.py
   (0 °dH = keine Angabe und > 60 °dH verworfen; typischer Wert = Median der Ortsteile).
   Härtebereiche nach WRMG § 9: weich < 8,4 · mittel 8,4–14 · hart > 14 °dH.
   Datenschutz: Die PLZ bleibt im Browser. An GA4 gehen nur Ergebnisart, Land und Härtebereich,
   und erst nach Analyse-Einwilligung (gleiches Muster wie alb-produktberater.js). */
(function () {
  'use strict';
  if (customElements.get('alb-wasserhaerte-check')) return;

  var GA4_ID = 'G-BKZBE7XSL1';

  function albGa4(eventName, params) {
    var p = { send_to: GA4_ID };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined && params[k] !== '') p[k] = params[k];
    }
    if (typeof window.gtag === 'function') { window.gtag('event', eventName, p); return; }
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('event', eventName, p);
  }

  function mitAnalyseEinwilligung(los) {
    var S = window.Shopify;
    var pruefen = function () {
      var cp = S && S.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) { los(); return; }
      var beiEntscheidung = function (e) {
        if (!(e && e.detail && e.detail.analyticsAllowed)) return;
        document.removeEventListener('visitorConsentCollected', beiEntscheidung);
        los();
      };
      document.addEventListener('visitorConsentCollected', beiEntscheidung);
    };
    if (S && S.customerPrivacy) { pruefen(); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { pruefen(); });
      return;
    }
    pruefen();
  }

  function bereich(wert) { return wert <= 8 ? 'weich' : (wert <= 14 ? 'mittel' : 'hart'); }
  function zahl(x) { return Number(x).toLocaleString('de-DE', { maximumFractionDigits: 1 }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = String(t); return d.innerHTML; }

  var cache = {};
  var warteschlange = [], einwilligungAngefragt = false, einwilligungErteilt = false;

  class AlbWasserhaerteCheck extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.urls = JSON.parse(this.getAttribute('data-urls') || '{}'); } catch (e) { this.urls = {}; }
      try { this.texte = JSON.parse(this.querySelector('script[data-texte]').textContent); } catch (e) { this.texte = {}; }
      this.form = this.querySelector('form');
      this.feld = this.querySelector('input[name="plz"]');
      this.knopf = this.querySelector('button[type="submit"]');
      this.meldung = this.querySelector('[data-meldung]');
      this.ergebnis = this.querySelector('[data-ergebnis]');
      if (!this.form || !this.feld || !this.ergebnis) return;
      var self = this;
      this.feld.addEventListener('input', function () {
        var sauber = self.feld.value.replace(/\D/g, '').slice(0, 5);
        if (sauber !== self.feld.value) self.feld.value = sauber;
        if (self.meldung) self.meldung.hidden = true;
      });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.suchen(); });
    }

    melde(text) {
      if (!this.meldung) return;
      this.meldung.textContent = text;
      this.meldung.hidden = false;
    }

    laden(schluessel) {
      if (cache[schluessel]) return cache[schluessel];
      var url = this.urls[schluessel];
      if (!url) return Promise.resolve(null);
      cache[schluessel] = fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (err) { delete cache[schluessel]; throw err; });
      return cache[schluessel];
    }

    suchen() {
      var plz = this.feld.value.replace(/\D/g, '');
      var t = this.texte;
      if (plz.length !== 5 && plz.length !== 4) {
        this.melde(t.ungueltig || 'Bitte gib eine Postleitzahl mit 5 Ziffern ein (Österreich 4 Ziffern).');
        this.ergebnis.hidden = true;          // altes Ergebnis nicht neben der Fehlermeldung stehen lassen
        this.zeigeEmpfehlung(null);
        this.zaehle('ungueltig');
        return;
      }
      var land = plz.length === 5 ? 'de' : 'at';
      var self = this;
      if (this.knopf) { this.knopf.disabled = true; this.knopf.setAttribute('aria-busy', 'true'); }
      this.laden(land + '-' + plz[0]).then(function (daten) {
        var e = daten && daten.d && daten.d[plz];
        if (!e) {
          self.zeigeKeinTreffer(plz);
          self.zaehle('kein_treffer', land);
          return;
        }
        self.zeige(plz, land, e);
        self.zaehle('treffer', land, bereich(e[1]));
      }).catch(function () {
        self.melde(t.fehler || 'Die Werte konnten gerade nicht geladen werden. Bitte versuche es gleich noch einmal.');
      }).then(function () {
        if (self.knopf) { self.knopf.disabled = false; self.knopf.removeAttribute('aria-busy'); }
      });
    }

    zeigeKeinTreffer(plz) {
      var t = this.texte;
      this.ergebnis.innerHTML =
        '<div class="alb-wh-karte alb-wh-karte--leer">' +
        '<p class="alb-wh-kicker">' + esc(t.kicker || 'Deine Wasserhärte') + '</p>' +
        '<p class="alb-wh-ort">' + esc(plz) + '</p>' +
        '<p class="alb-wh-text">' + esc(t.kein_treffer || 'Für diese Postleitzahl haben wir keinen Wert. Dein Wasserversorger nennt dir den Härtebereich, meist auf seiner Website.') + '</p>' +
        '</div>';
      this.ergebnis.hidden = false;
      this.zeigeEmpfehlung(null);
      this.fokus();
    }

    zeige(plz, land, e) {
      var t = this.texte;
      var ort = e[0], typ = e[1], lo = e[2], hi = e[3], gruppen = e[4] || [];
      var spanne = hi - lo > 2;
      var b = bereich(typ), bLo = bereich(lo), bHi = bereich(hi);
      var bereichText = spanne && bLo !== bHi ? bLo + ' bis ' + bHi : b;
      var wert = spanne ? zahl(lo) + '–' + zahl(hi) : 'ca. ' + zahl(typ);
      var satz = spanne
        ? (t.satz_spanne || 'Je nach Ortsteil liegt die Härte zwischen {min} und {max} °dH. Das ist {bereich}.')
        : (t.satz_einzeln || 'Das Leitungswasser hat hier etwa {wert} °dH. Das gilt als {bereich}.');
      satz = satz.replace('{min}', zahl(lo)).replace('{max}', zahl(hi)).replace('{wert}', zahl(typ)).replace('{bereich}', '<strong>' + esc(bereichText) + '</strong>');

      // Skala 0–30 °dH (darüber am Ende): weich bis 8,4 · mittel bis 14 · hart
      var pos = function (x) { return Math.max(0, Math.min(100, x / 30 * 100)); };
      var marke = spanne
        ? '<span class="alb-wh-skala-band" style="left:' + pos(lo) + '%;width:' + Math.max(2, pos(hi) - pos(lo)) + '%"></span>'
        : '<span class="alb-wh-skala-punkt" style="left:' + pos(typ) + '%"></span>';

      var liste = '';
      if (gruppen.length > 1) {
        liste = '<details class="alb-wh-ortsteile"><summary>' + esc(t.ortsteile || 'Werte je Ortsteil') + '</summary><ul>' +
          gruppen.map(function (g) { return '<li><strong>' + zahl(g[0]) + '&nbsp;°dH</strong> ' + esc(g[1]) + '</li>'; }).join('') +
          '</ul></details>';
      }

      this.ergebnis.innerHTML =
        '<div class="alb-wh-karte alb-wh-karte--' + b + '">' +
          '<p class="alb-wh-kicker">' + esc(t.kicker || 'Deine Wasserhärte') + '</p>' +
          '<p class="alb-wh-ort">' + esc(plz) + ' ' + esc(ort) + (land === 'at' ? ' <span class="alb-wh-land">(AT)</span>' : '') + '</p>' +
          '<p class="alb-wh-wert"><span>' + wert + '</span>&nbsp;°dH</p>' +
          '<p class="alb-wh-text">' + satz + '</p>' +
          '<div class="alb-wh-skala" aria-hidden="true">' +
            '<div class="alb-wh-skala-bahn"><span class="alb-wh-zone alb-wh-zone--weich"></span><span class="alb-wh-zone alb-wh-zone--mittel"></span><span class="alb-wh-zone alb-wh-zone--hart"></span>' + marke + '</div>' +
            '<div class="alb-wh-skala-labels"><span>weich</span><span>mittel</span><span>hart</span></div>' +
          '</div>' +
          liste +
          '<div class="alb-wh-bedeutung">' + (t['bedeutung_' + b] || '') + '</div>' +
          '<p class="alb-wh-hinweis">' + esc(t.hinweis || '') + '</p>' +
        '</div>';
      this.ergebnis.hidden = false;
      this.zeigeEmpfehlung(b);
      this.fokus();
    }

    zeigeEmpfehlung(b) {
      var boxen = this.querySelectorAll('[data-empfehlung]');
      boxen.forEach(function (box) { box.hidden = !(b && box.getAttribute('data-empfehlung') === b); });
    }

    fokus() {
      var karte = this.ergebnis.querySelector('.alb-wh-karte');
      if (!karte) return;
      karte.setAttribute('tabindex', '-1');
      try {
        karte.focus({ preventScroll: true });
        // Nur scrollen, wenn die Karte nicht schon gut sichtbar ist (Desktop: steht meist direkt unter dem Feld)
        var r = karte.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < 0 || r.top > vh * 0.45) karte.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      } catch (e) {}
    }

    zaehle(ergebnis, land, b) {
      warteschlange.push({ ergebnis: ergebnis, land: land ? land.toUpperCase() : undefined, haertebereich: b });
      if (einwilligungAngefragt) return;          // nur EIN wartender Einwilligungs-Aufruf je Seite
      einwilligungAngefragt = true;
      mitAnalyseEinwilligung(function () {
        einwilligungErteilt = true;
        while (warteschlange.length) albGa4('alb_wasserhaerte_check', warteschlange.shift());
      });
      if (einwilligungErteilt) while (warteschlange.length) albGa4('alb_wasserhaerte_check', warteschlange.shift());
    }
  }

  customElements.define('alb-wasserhaerte-check', AlbWasserhaerteCheck);
})();
